















































































import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Select from '@/components/Select.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import { ISelectItem } from '@/interfaces'
import moment from 'moment'
import CollectionSharedFunctions from '@/views/app/management/collections/CollectionSharedFunctions'

@Component({
  props: {
    newTask: {
      required: true
    }
  },
  components: { TextArea, Select, Icon, DateInput }
})
export default class CollectionActionSchedule extends CollectionSharedFunctions {
  dateFrom: Date = new Date()
  // dateFrom: Date = new Date(Date.now() + (24 * 60 * 60 * 1000))

  // @NoCache
  // get newTaskTime () {
  //   if (!this.$props.newTask.taskDate) {
  //     return undefined
  //   }
  //   const taskDate: Date = this.$props.newTask.taskDate as Date
  //   const hours = taskDate.getHours()
  //   const minutes = taskDate.getMinutes()
  //   return `${hours}-${minutes}`
  // }

  get timeListItems () {
    const timeIntervals = {
      '0-0': '12:00 AM',
      '0-30': '12:30 AM',
      '1-0': '1:00 AM',
      '1-30': '1:30 AM',
      '2-0': '2:00 AM',
      '2-30': '2:30 AM',
      '3-0': '3:00 AM',
      '3-30': '3:30 AM',
      '4-0': '4:00 AM',
      '4-30': '4:30 AM',
      '5-0': '5:00 AM',
      '5-30': '5:30 AM',
      '6-0': '6:00 AM',
      '6-30': '6:30 AM',
      '7-0': '7:00 AM',
      '7-30': '7:30 AM',
      '8-0': '8:00 AM',
      '8-30': '8:30 AM',
      '9-0': '9:00 AM',
      '9-30': '9:30 AM',
      '10-0': '10:00 AM',
      '10-30': '10:30 AM',
      '11-0': '11:00 AM',
      '11-30': '11:30 AM',
      '12-00': '12:00 PM',
      '12-30': '12:30 PM',
      '13-00': '1:00 PM',
      '13-30': '1:30 PM',
      '14-00': '2:00 PM',
      '14-30': '2:30 PM',
      '15-00': '3:00 PM',
      '15-30': '3:30 PM',
      '16-00': '4:00 PM',
      '16-30': '4:30 PM',
      '17-00': '5:00 PM',
      '17-30': '5:30 PM',
      '18-00': '6:00 PM',
      '18-30': '6:30 PM',
      '19-00': '7:00 PM',
      '19-30': '7:30 PM',
      '20-00': '8:00 PM',
      '20-30': '8:30 PM',
      '21-00': '9:00 PM',
      '21-30': '9:30 PM',
      '22-00': '10:00 PM',
      '22-30': '10:30 PM',
      '23-00': '11:00 PM',
      '23-30': '11:30 PM'
    }
    return Object.keys(timeIntervals).map((key: any, index: number) => {
      return {
        key: index,
        value: key,
        // @ts-ignore
        content: timeIntervals[key]
      }
    })
  }

  setNewTaskField (propName: string, item: any) {
    this.$set(this.$props.newTask, propName, item)
    this.$forceUpdate()
  }

  selectNewTaskField (propName: string, item: ISelectItem) {
    this.$set(this.$props.newTask, propName, item.value)
    this.$forceUpdate()
  }

  changeNewTaskDate (date: Date | string | null) {
    if (!date) {
      this.$delete(this.$props.newTask, 'taskDate')
      return
    }
    this.$set(this.$props.newTask, 'taskDate', moment(date).utc(false).set('hour', 12).set('minute', 0).add(this.user.getTimezone(), 'hours').toDate())
    // this.$forceUpdate()
  }

  // changeNewTaskTime (item: ISelectItem) {
  //   if (!this.$props.newTask.taskDate) {
  //     this.$props.newTask.taskDate = new Date(new Date().toLocaleDateString(navigator.language))
  //   }
  //   const taskDate: Date = this.$props.newTask.taskDate as Date
  //   const times: number[] = item.value.split('-').map(Number)
  //   taskDate.setHours(times[0])
  //   taskDate.setMinutes(times[1])
  //   this.$forceUpdate()
  // }

  get validateScheduleTask () {
    return this.$props.newTask.note &&
        this.$props.newTask.assignedUser &&
        this.$props.newTask.contactToCall &&
        this.$props.newTask.taskDate
  }

  async scheduleCall () {
    if (!this.validateScheduleTask) {
      return
    }
    this.$emit('submit', {
      functionName: 'scheduleCallWithResident',
      successMessage: 'Call Scheduled',
      payloadData: {
        note: this.$props.newTask.note as string,
        contactToCall: this.$props.newTask.contactToCall,
        taskDate: this.$props.newTask.taskDate,
        assignedUser: this.$props.newTask.assignedUser
      }
    })
  }
}
